export enum RuleConditionField {
    EMAIL = 'email',
    EMAIL_DOMAIN = 'email_domain',
    REQUEST_KEYWORD = 'subject',
    REQUESTOR_STATE = 'state',
    TEAM = 'team',
    GID = 'gid',
    ASSIGNEE = 'assignee',
    COUNTRY = 'country',
    CLASSIFICATION = 'classification',
    TYPE_NAME = 'typeName'
}
